'use strict';exports.__esModule = true;exports.commodityValidator = undefined;var _lodash = require('lodash');
var _constants = require('../../constants');
var _validate = require('../../utils/validate');
var _constants2 = require('./constants');

var validate = function validate(values, _ref) {var isForeign = _ref.isForeign;
  var errors = {};

  if (!values.minimal_price && !values.exact_price) {
    errors.minimal_price = 'emptyField';
    errors.exact_price = 'emptyField';
  }

  if (values.minimal_price && values.exact_price) {
    errors.minimal_price = 'emptyField';
    errors.exact_price = 'emptyField';
  }

  if (!values.status) {
    errors.status = 'emptyField';
  }

  if (!values.completion_date_years) {
    errors.completion_date_years = 'emptyField';
  }

  if (!values.property_types) {
    errors.property_types = 'emptyField';
  }

  if (!values.room_range) {
    errors.room_range = 'emptyField';
  }

  if (!values.projectImages || !values.projectImages.length) {
    errors.projectImages = 'emptyField';
  }

  if (!values.project_img || !values.project_img.link) {
    errors.project_img = 'emptyField';
  }

  if (!values.apartments) {
    errors.apartments = 'emptyField';
  }

  if (!values.buildings) {
    errors.buildings = 'emptyField';
  }

  if (!values.floors) {
    errors.floors = 'emptyField';
  }

  if (!(0, _validate.phoneRegexValidation)(values.phone_number) ||
  !(!!values.phone_number && values.phone_number.length >= 12 && values.phone_number.length <= 15))
  {
    errors.phone_number = 'emptyField';
  }

  var advantages = (0, _lodash.get)(values, _constants2.PROJECT_FIELDS_NAMES.advantages);

  if (advantages) {
    var advantagesArrayErrors = [];
    advantages.forEach(function (advantage, index) {
      var advantageError = {};

      var description = (0, _lodash.get)(advantage, 'description');
      var title = (0, _lodash.get)(advantage, 'title');
      if (description && !title) {
        advantageError.title = 'emptyField';
      }
      if (!description && title) {
        advantageError.description = 'emptyField';
      }

      advantagesArrayErrors[index] = advantageError;
    });

    if (advantagesArrayErrors.length) {
      errors.advantages = advantagesArrayErrors;
    }
  }

  var name = (0, _lodash.get)(values, 'name_project.' + (isForeign ? _constants.language.fallback : _constants.language.default));

  if (!name) {
    errors.name_project = {};
    errors.name_project[isForeign ? _constants.language.fallback : _constants.language.default] = 'emptyField';
  }

  var summary = (0, _lodash.get)(values, 'summary.' + (isForeign ? _constants.language.fallback : _constants.language.default));

  if (!summary) {
    errors.summary = {};
    errors.summary[isForeign ? _constants.language.fallback : _constants.language.default] = 'emptyField';
  }

  var description = (0, _lodash.get)(values, 'description.' + (isForeign ? _constants.language.fallback : _constants.language.default));
  if (!description) {
    errors.description = {};
    errors.description[isForeign ? _constants.language.fallback : _constants.language.default] = 'emptyField';
  }

  return errors;
};exports.default =

validate;

var commodityValidator = exports.commodityValidator = function commodityValidator() {var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var errors = [];

  if (!Array.isArray(value)) return undefined;
  value.forEach(function (item, currentIndex) {
    if (item.type && (!item.items || item.items.length < 1)) {
      errors[currentIndex] = 'atLeastOne';
    }
    if (!item.type && item.items && item.items.length > 0) {
      errors[currentIndex] = 'required';
    }
  });
  return (0, _lodash.isEmpty)(errors) ? undefined : errors;
};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/validate.js
// module id = 1256
// module chunks = 0